// Datos públicos del sitio (landing + páginas legales).
// Los campos vacíos se muestran como "[... pendiente]" en las páginas legales
// y se ocultan en la landing. Llenar antes de desplegar las páginas legales.
const SITE = {
  brand: 'Talku',
  domain: 'talku.online',

  // PENDIENTE: número de WhatsApp de ventas en formato internacional sin "+" (ej. 573001234567).
  // Si está vacío, el CTA principal es "Crear cuenta" en vez de "Solicitar demo".
  whatsapp: '',
  // PENDIENTE: correo de soporte / contacto legal.
  email: '',
  // PENDIENTE: ciudad y país.
  city: '',
  // PENDIENTE: razón social o nombre del responsable, y NIT / cédula.
  legalName: '',
  legalId: '',

  // Mostrar la sección de precios (cuando existan planes definidos).
  showPricing: false,
  // Permitir registro abierto (botón "Crear cuenta").
  openSignup: true,

  legalUpdated: '24 de septiembre de 2026',
};

export function whatsappLink(text) {
  if (!SITE.whatsapp) return null;
  const q = text ? `?text=${encodeURIComponent(text)}` : '';
  return `https://wa.me/${SITE.whatsapp}${q}`;
}

export default SITE;
